import { forwardRef } from 'react';

import { Colors, TextVariants } from '@lichtblick/theme';
import { ApprovalState } from '@lichtblick/types';

import { ArrowForwardIosIcon, CardContainer, Dot, StatusContainer } from './WorkItemCard.styles';

import { Chip } from '../Chip';
import { Text } from '../Text';

type WorkItemCardProps = {
  isSelected: boolean;
  name: string;
  status: ApprovalState;
};

const variantMap = (variant: ApprovalState) => {
  switch (variant) {
    case ApprovalState.Open:
      return Colors.gray[100];
    case ApprovalState.Pending:
    case ApprovalState.Resubmitted:
      return Colors.orange[100];
    case ApprovalState.Rejected:
      return Colors.red[100];
    case ApprovalState.ServerApproved:
    case ApprovalState.ClientApproved:
      return Colors.green[100];
    default:
      return '';
  }
};

export const WorkItemCard = forwardRef<HTMLDivElement, WorkItemCardProps>(({ isSelected, name, status }, ref) => {
  return (
    <CardContainer $isSelected={isSelected} data-testid="cardContainer" ref={ref}>
      <Dot $color={variantMap(status)} data-testid="dot" />
      <StatusContainer>
        <Text $variant={TextVariants.body.l}>{name}</Text>
        <Chip size="small" variant={status}></Chip>
      </StatusContainer>
      <ArrowForwardIosIcon />
    </CardContainer>
  );
});
